// Plain-data free-tools list — the single source of truth for the list itself.
//
// Kept as .mjs (with toolsList.d.ts for types, same pattern as src/seo/pages.mjs)
// so BOTH consumers read one array:
//   - toolsRegistry.tsx — attaches the icons and exports TOOLS to the app
//   - scripts/prerender-seo.mjs — a plain Node build script that cannot import TSX
//
// ORDER = measured Japanese search volume × relevance (see
// docs/MARKET_STRATEGY_2026-08.md §2.4/§2.5), families kept contiguous:
// business-writing AI (敬語変換 ~50k/mo … ) → PDF×AI (category proven by the
// chat-with-PDF brand demand) → site diagnostics (OGP ~2.2k / dead links
// ~1.8k / sitemap ~1.2k) → conversion components (dead keywords, kept for
// the funnel).
//
// `how` selects which shared 使い方 copy group the page shows
// (portal.tools.how<How>1..3) and MUST match the shell the page renders:
// TextToolPage=Write, PdfToolShell=Pdf, UrlToolShell=Url, FaqGenerator=Faq,
// RoiCalculator=Roi. prerender-seo.mjs asserts the copy exists.
export const TOOL_LIST = [
  { path: '/tools/keigo-converter', key: 'keigo', docs: '/docs/tools-writing#keigo', how: 'Write' },
  { path: '/tools/apology-mail', key: 'apology', docs: '/docs/tools-writing#apology', how: 'Write' },
  { path: '/tools/proofreader', key: 'proofread', docs: '/docs/tools-writing#proofread', how: 'Write' },
  { path: '/tools/inquiry-reply', key: 'inquiry', docs: '/docs/tools-writing#inquiry', how: 'Write' },
  { path: '/tools/pdf-summarizer', key: 'pdfsum', docs: '/docs/tools-pdf#pdfsum', how: 'Pdf' },
  { path: '/tools/pdf-to-text', key: 'pdftext', docs: '/docs/tools-pdf#pdftext', how: 'Pdf' },
  { path: '/tools/pdf-to-markdown', key: 'pdfmd', docs: '/docs/tools-pdf#pdfmd', how: 'Pdf' },
  { path: '/tools/ogp-checker', key: 'ogp', docs: '/docs/tools-site#ogp', how: 'Url' },
  { path: '/tools/link-checker', key: 'link', docs: '/docs/tools-site#link', how: 'Url' },
  { path: '/tools/sitemap-generator', key: 'sitemap', docs: '/docs/tools-site#sitemap', how: 'Url' },
  { path: '/tools/faq-generator', key: 'faq', docs: '/docs/tools-chatbot#faq', how: 'Faq' },
  { path: '/tools/chatbot-roi', key: 'roi', docs: '/docs/tools-chatbot#roi', how: 'Roi' },
  { path: '/tools/crawl-preview', key: 'crawl', docs: '/docs/tools-site#crawl', how: 'Url' },
];
